import { cn } from '@qr-front/ui/utils'
import { ReactNode, useContext } from 'react'

import { TSvgIcon } from '@/types'

import { TLabeledContactEntry } from '../../../../contentFormSections/CommonSections/ContactSection'
import { IsPreviewModeContext } from './vCardScreenContexts'

export const SectionIcon = ({ Icon }: { Icon: TSvgIcon }) => (
	<div className="flex size-8 shrink-0 items-center justify-center rounded-4 bg-light-grey-70 text-grey">
		<Icon className="size-4" />
	</div>
)

type TContactItem = {
	label?: string
	Icon: TSvgIcon
	value: string | string[] | TLabeledContactEntry[]
	ValueWrapper?: (props: { value: string; className: string }) => ReactNode
}

export const ContactItem = ({
	contactItem: {
		label,
		Icon,
		value,
		ValueWrapper = ({ value, className }) => (
			<span className={className}>{value}</span>
		),
	},
}: {
	contactItem: TContactItem
}) => {
	const isPreviewMode = useContext(IsPreviewModeContext)

	const normalizedValueList: TLabeledContactEntry[] = (
		Array.isArray(value) ? value : [value]
	).map((item) =>
		typeof item === 'string' ? { value: item, label: label ?? '' } : item,
	)

	return (
		<li>
			<ul className="flex flex-col gap-4">
				{normalizedValueList.map(
					({ value, label: entryLabel }, index) => (
						<li key={index} className="flex items-center gap-4">
							{index === 0 ? <SectionIcon Icon={Icon} /> : null}
							<div
								key={value}
								className={cn(
									'flex flex-col word-break-fix',
									!isPreviewMode &&
										'tablet:flex-row tablet:items-center tablet:gap-2',
									index > 0 && 'pl-12',
								)}
							>
								<label className="whitespace-nowrap text-10 leading-[20px]">
									{entryLabel}
								</label>
								<ValueWrapper
									className={cn(
										'type-body-caption w-full break-words',
									)}
									value={value}
								/>
							</div>
						</li>
					),
				)}
			</ul>
		</li>
	)
}
